import { Navigate } from "react-router-dom";
import { DecodedToken } from "../models/DecodedToken";
import { ReactElement } from "react";
import { decodeToken } from "../helperMethods/decodeToken";

export function RoleBasedRoute({ children }: { children: ReactElement }) {
  const token = localStorage.getItem('token');

  if (!token) return <Navigate to="/login" />;

  try {
    const decoded: DecodedToken = decodeToken(token);

    if (decoded.isAdmin === 'True' || decoded.isAdmin === "True") return children;

    const pathname = window.location.pathname;

    if (decoded.isEsimReseller === 'True') {
      if (['/', '/sale/qr','/topUpEsim','/balance'].includes(pathname) || pathname.startsWith('/package/')) {
        return children;
      }
    } else {
      if (pathname === '/assign-sim-package' || pathname ==="/balance") {
        return children;
      }
    }

    return <Navigate to="/" />;
  } catch {
    localStorage.removeItem('token');
    return <Navigate to="/login" />;
  }
}

